import { amountFormat, amountToNumber } from '../../../../util/shared/vue-global';

export const applyAuditForPayment = ({
  item, initialPenaltyAmt, initialTaxAmt, item1,
  taxAmountChangesCreateAudit = false,
}) => {
  const auditMessages = [];
  let AIsVisible = false;
  // const halfPayment = amountToNumber(initialTaxAmt || 0) / 2;
  const suffix = `for Tax ID: ${item.taxId} and Tax Year: ${item.taxYear} `;

  const initialFees = item.initialFees || [];
  const currentFees = item.fees || [];

  currentFees.forEach((fee) => {
    const matchedInitialFee = initialFees
      .find((initialFee) => initialFee.feeNumber === fee.feeNumber);
    if (!matchedInitialFee) {
      AIsVisible = true;
      auditMessages.push(`Fee ${fee.feeNumber} for ${amountFormat(fee.feeAmount)} was added ${suffix}`);
    } else if (amountToNumber(fee.feeAmount) !== amountToNumber(matchedInitialFee.feeAmount)) {
      AIsVisible = true;
      auditMessages.push(`Fee ${fee.feeNumber} was changed from ${amountFormat(matchedInitialFee.feeAmount)} to ${amountFormat(fee.feeAmount)} ${suffix}`);
    }
  });

  initialFees.forEach((initialFee) => {
    const stillExists = currentFees
      .some((fee) => fee.feeNumber === initialFee.feeNumber);
    if (!stillExists) {
      AIsVisible = true;
      auditMessages.push(`Fee ${initialFee.feeNumber} for ${amountFormat(initialFee.feeAmount)} was deleted ${suffix}`);
    }
  });

  if (amountToNumber(initialPenaltyAmt) !== amountToNumber(item.penaltyAmt)) {
    AIsVisible = true;
    auditMessages.push(`Penalty changes from ${amountFormat(initialPenaltyAmt)} to ${amountFormat(item.penaltyAmt)} ${suffix}`);
  }
  // if ((amountToNumber(halfPayment) > amountToNumber(item.taxAmt)))
  const taxAmountChanged = amountToNumber(initialTaxAmt) !== amountToNumber(item.taxAmt);
  if (item1.isFirstTimePrintReceipt
    || (taxAmountChangesCreateAudit && taxAmountChanged)) {
    AIsVisible = true;
    auditMessages.push(`Tax amount changes from ${amountFormat(initialTaxAmt)} to ${amountFormat(item.taxAmt)} ${suffix}`);
  }
  let auditSummary = auditMessages.join('\n');
  if (item1.isFirstTimePrintReceipt) {
    auditSummary += ', change was made after receipt had been printed';
  }
  return {
    auditSummaryText: auditSummary,
    aIsVisible: AIsVisible,
  };
};

/**
 * What a hand-edited tax detail row looks like afterwards: the audit summary and the 'A' flag
 * the row carries, and the grossAssessed rescaled to whatever share of the tax is being paid.
 *
 * This is TaxEditDialog.handleManualChanges' body, lifted out because the Type can now also be
 * changed on the line in the large payment grid without opening that dialog - and both paths
 * have to leave the row in the same state. Pure: it returns a new row rather than writing one.
 *
 * The TAXPAYMENT gate is the point of it for a type change: an audit record only means
 * something on a payment line, so a refund / credit / transfer row carries no summary and no
 * flag, which is exactly what the old dialogTaxDetails grid did when the type was picked first.
 *
 * @param {Object} row                        the row as it is AFTER the edit
 * @param {Object} paymentTransaction         item('paymentTransactionList') - read for
 *                                            isFirstTimePrintReceipt
 * @param {Boolean} taxAmountChangesCreateAudit  payment setting of the same name
 * @returns {Object} the row with auditSummary / AIsVisible / grossAssessed settled
 */
export const applyManualChangesToRow = ({
  row, paymentTransaction = {}, taxAmountChangesCreateAudit = false,
}) => {
  const {
    initialPenaltyAmt, initialTaxAmt, grossAssessed, taxAmt,
  } = row;
  // The share of the record's tax this line is paying, which the assessed value is scaled to.
  // A row with no baseline tax - a 0.00 record, or one that arrived without initialTaxAmt - has
  // no percentage to scale by: 0/0 is NaN, and a NaN grossAssessed fails the upsert. Such a row
  // keeps the assessed value it came with rather than being given an invented one.
  const baselineTax = amountToNumber(initialTaxAmt);
  const taxPercentage = baselineTax ? (amountToNumber(taxAmt) * 100) / baselineTax : null;
  // audit records are only needed when the tax-type is 'TAXPAYMENT'
  const isItTaxPayment = row.taxType === 'TAXPAYMENT';
  const { auditSummaryText, aIsVisible } = applyAuditForPayment({
    item: row,
    initialPenaltyAmt,
    initialTaxAmt,
    item1: paymentTransaction || {},
    taxAmountChangesCreateAudit,
  });

  const changedValue = {
    ...row,
    grossAssessed: taxPercentage === null
      ? grossAssessed
      : (grossAssessed * taxPercentage) / 100,
    auditSummary: isItTaxPayment ? auditSummaryText : '',
    AIsVisible: isItTaxPayment ? aIsVisible : false,
  };
  if (taxAmountChangesCreateAudit && aIsVisible && isItTaxPayment) {
    changedValue.previousTaxAmt = initialTaxAmt;
  }
  return changedValue;
};

export default { applyAuditForPayment, applyManualChangesToRow };
